/**
 * MP User JS
 *
 * JS included here should only be used on the public / registered user-side of 
 * the app (i.e. any route WITHOUT /admin)
 */

//Setting negative margin for grey skewed CTAs so they stay vertically centered
if ($(window).width() > 959) {
   setTimeout(function(){
  	var mpCtasHeight = $('.mp-skewed-ctas').outerHeight();
  	$('.mp-skewed-ctas').animate({marginTop:-mpCtasHeight/2});
	}, 100);
}

$(document).ready(function() {

  if(typeof Isotope != "undefined"){
    $('.mp-isotope-grid').each(function(i, e){
      console.log(e);
      var iso = new Isotope(e, {
        itemSelector: '.mp-position',
        percentPosition: true,
        masonry: {
          // use element for option
          columnWidth: '.mp-position',
          gutter: 20
        }
      });
    });
  }

  // Autocomplete search
  var client = algoliasearch('2XFTNAFC7L', '5f01687e1150902cbfffdf6c20ad4939');
  var index = client.initIndex('services_index');
  autocomplete('.ac[name="q"]', { hint: false }, [
    {
      source: autocomplete.sources.hits(index, { hitsPerPage: 5 }),
      displayKey: 'name',
      templates: {
        suggestion: function(suggestion) {
          return `<a href='/services/${suggestion.slug}'><div class='mp-algolia-result'>${suggestion._highlightResult.name.value}</div></a>`;
        }
      }
    }
  ]).on('autocomplete:selected', function(event, suggestion, dataset) {
  });

  // Rough calculate distance from user on pages with address fields
  if($('.mp-address, .mp-requires-geo').length > 0){

    $('.mp-filter-postcode').on('blur', updatePostcodeHandler);
    var lat = $('input[name="userlat"]').val();
    var lng = $('input[name="userlng"]').val();
    if(lat && lng){
      updateDistancesHandler(lat, lng);
    }

  }

  $('.mp-tag-selector').on('change', function(e) {
    window.location.href = $('option:selected', this).val();
  })

  // Trigger filters on submit
  $('.mp-trigger-submit').on('change', function(){
    $('.mp-filter-form').trigger('submit');
  });
  $('.mp-submit-filter').on('click', function(){
    $('.mp-filter-form').trigger('submit');
  });

  // Update range value
  $('input[type="range"]').on('input', function(){
    var diff = parseInt($(this).val()) / parseInt($(this).attr('max'));
    var width = ($(this).width() * diff) - ($(this).prev().width()*diff);
    $(this).prev().css('left', width+'px');
    $(this).prev().text($(this).val());
  });

  // Trigger input on ranges to align values above
  $('.mp-range-value').each(function(){
    $(this).next().trigger('input');
  });

  // Toggle between 'any' and 'choose', including field state
  $('.mp-range-any').on('click', function(){
    $(this).addClass('uk-button-secondary');
    $(this).next().removeClass('uk-button-secondary');
    $(this).parents('.mp-range').children('.mp-range-chooser').addClass('uk-hidden');
    $(this).parents('.mp-range').find('input').attr('disabled', 'disabled');
    $('.mp-filter-form').trigger('submit');
  });

  // Toggle between 'any' and 'choose', including field state
  $('.mp-range-choose').on('click', function(){
    $(this).addClass('uk-button-secondary');
    $(this).prev().removeClass('uk-button-secondary');
    $(this).parents('.mp-range').children('.mp-range-chooser').removeClass('uk-hidden');
    $(this).parents('.mp-range').find('input').trigger('input');
    $(this).parents('.mp-range').find('input').removeAttr('disabled');
  });

  // This is horrible and justifies using state!
  $('.mp-show-filters').on('click', function(){
    $('.mp-button-message').text($('.mp-button-message').text() == "Show all filters" ? "Hide all filters" : "Show all filters");
    var visibilityClass = $('.mp-filter-form').hasClass('uk-visible@m') ? 'uk-hidden@m' : 'uk-visible@m';
    var animationClass = $('.mp-filter-form').hasClass('uk-animation-slide-top-small') ? '': 'uk-animation-slide-top-small';
    $('.mp-filter-form').removeClass('uk-hidden@m uk-visible@m uk-animation-slide-top-small').addClass(visibilityClass).addClass(animationClass);
    UIkit.update(element = document.body, event = 'update');
  });

  // Create new empty directory associated with user
  $('.mp-create-directory').on('click', createNewDirectoryHandler);

  // Create new empty directory associated with user
  $('.mp-update-directory').on('click', updateDirectoryHandler);

  // Delete directories, if owned by active user
  $('.mp-delete-directory').on('click', function(){
    var slug = $(this).parents('tr').attr("data-mp-directory-slug");
    deleteDirectoryHandler(slug);
  });

  // SHow modal with directory link
  $('.mp-copy-directory-link').on('click', copyDirectoryLinkHandler);

  // Update UI on PDF download
  $('.mp-download-directory').on('click', function(){
    var that = this;
    var href = $(this).attr('href');

    setTimeout(function(){
      $(that).attr('href', '#');
      $(that).html('<div uk-spinner="ratio: 0.5"></div> Creating PDF...');
    }, 100);
    setTimeout(function(){
      $(that).text('Export to PDF');
      $(that).attr('href', href);
    }, 12500);
  });

  // Add service to directory
  $('.mp-add-service-to-directory').on('click', addServiceToDirectoryHandler);

  $('.mp-remove-service-from-directory').on('click', removeServiceFromDirectoryHandler);

  // Post email on feedback
  $('.mp-feedback-send').on('click', sendFeedbackHandler);



  $('.mp-hero-overlay-homepage').css('min-height', $('.mp-top-banner').css('min-height'));

});


function updatePostcodeHandler(){
  var postcode = $(this).val();
  var prevPostcode = $(this).attr('data-mp-prev-postcode');
  if(postcode == prevPostcode)
    return;

  postcode = postcode.replace(/ /g,'');
  if(postcode == ""){
    // Reset
    $('input[name="userlat"]').val('');
    $('input[name="userlng"]').val('');
    $('.mp-distance').addClass("uk-hidden");
    return;
  }

  $(this).attr('data-mp-prev-postcode', postcode);

  var axiosCrossDomain = axios;
  delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];

  $.get({
    url: 'https://maps.googleapis.com/maps/api/geocode/json?address='+postcode+'&key=AIzaSyCB7mIIB2zraftUr9c5EuQIGxrsqMASbB4',
    success: function(response){
      if(response.results){
        if(response.results[0]){
          var lat = response.results[0].geometry.location.lat;
          var lng = response.results[0].geometry.location.lng;
          $('input[name="userlat"]').val(lat);
          $('input[name="userlng"]').val(lng);
          updateDistancesHandler(lat, lng);
        }
      }
    }
  });

}

function updateDistancesHandler(lat, lng){

      $('.mp-requires-geo').removeClass("uk-hidden");
      $('.mp-address').each(function(){

        var addressLat = $('input[name="lat"]', this).val();
        var addressLng = $('input[name="lat"]', this).val();
        if(addressLat !== "" && addressLng !== ""){
          var dist = getDistanceFromLatLonInKm(
            $('input[name="lat"]', this).val(),
            $('input[name="lng"]', this).val(),
            lat,
            lng);
          dist = Math.round( dist * 10 ) / 10;
          if(isNumeric(dist)){
            $('.mp-distance-value', this).text(dist);
            $('.mp-distance', this).removeClass('uk-hidden');
          }
        }

      });

      UIkit.update(element = document.body, event = 'update');
}

/**
 * Adds a service to a directory, creating a new directory if selected
 */
function addServiceToDirectoryHandler(){
  var directorySlug = $('.mp-selected-directory').val();
  var serviceSlug = $(this).parents('.mp-service').attr('data-mp-service-slug');

  if(directorySlug == ""){
    UIkit.modal.prompt('Directory Name', '').then(function(directoryName){

      if(directoryName == ""){
        return;
      }
      axios.post('/directories/store', {
          name: directoryName
        })
        .then(function (response) {
          $('.mp-selected-directory').append("<option value='"+response.data.slug+"'>"+response.data.name+"</option>");
          $('.mp-selected-directory option[value="'+response.data.slug+'"]').attr('selected', 'selected');
          $('.mp-add-service-to-directory').trigger('click');
        })
        .catch(function (error) {
          console.error(error);
          rg4js('send', {
            error: error,
            customData: [error.response]
          });
        });

    });
  }

  // Need to check if slug is empty, but for now
  axios.get('/directories/'+directorySlug+'/add/'+serviceSlug)
    .then(function (response) {
      UIkit.notification({status: 'success', message: '<span uk-icon=\'icon: check\'></span> Added to directory!'});
      $('.mp-selected-directory option:selected').addClass('uk-text-muted').attr('disabled', 'disabled');
    })
    .catch(function (error) {
      console.error(error);
      rg4js('send', {
        error: error,
        customData: [error.response]
      });
    });
}

function removeServiceFromDirectoryHandler(){
  // Need to check if slug is empty, but for now
  var directorySlug = $(this).attr('data-mp-directory-slug');
  var serviceSlug = $(this).attr('data-mp-service-slug');
  var that = this;
  axios.get('/directories/'+directorySlug+'/remove/'+serviceSlug)
    .then(function (response) {
      UIkit.notification({status: 'success', message: '<span uk-icon=\'icon: check\'></span> Removed from directory!'});
      $(that).closest('li').slideUp();
      setTimeout(() => { window.location.reload(); }, 2000);
    })
    .catch(function (error) {
      console.error(error);
      rg4js('send', {
        error: error,
        customData: [error.response]
      });
    });
}

/**
 * Send a feedback email on a given Service
 */
function sendFeedbackHandler(){
  var that = $(this);
  var slug = $(this).closest('form').attr('data-mp-service-slug');

  axios.post('/feedback/'+slug, {
      email: $(this).closest('form').find('input').val(),
      message: $(this).closest('form').find('textarea').val(),
    })
    .then(function (response) {
      UIkit.modal(that.closest('[uk-modal]')).hide();
      UIkit.notification({status: 'success', message: '<span uk-icon=\'icon: check\'></span> Feedback sent!'});
    })
    .catch(function (error) {
      console.error(error);
      rg4js('send', {
        error: error,
        customData: [error.response]
      });
    });
}


/**
 * Show an alert with the Directory's public link
 */
function copyDirectoryLinkHandler(){
  var link = $(this).attr('data-mp-directory-link');
  UIkit.modal.dialog('<div class="uk-modal-body uk-text-center"><p>Access your directory at:</p><pre>'+link+'</pre></div>');
}

/**
 * Update Directory settings
 */
function updateDirectoryHandler(){
  var slug = $(this).closest('form').attr('data-mp-directory-slug');

  axios.put('/directories/update/'+slug, {
      name: $(this).closest('form').find('input').val(),
      is_public: parseInt($(this).closest('form').find('select').val()),
      description: $(this).closest('form').find('textarea').val(),
    })
    .then(function (response) {
      window.location.reload();
    })
    .catch(function (error) {
      console.error(error);
      rg4js('send', {
        error: error,
        customData: [error.response]
      });
    });
}

/**
 * Create a new empty Directory
 */
function createNewDirectoryHandler(){
  UIkit.modal.prompt('Directory Name', '').then(function(directoryName){
    // Go up to the cloud and create this
    // Once complete, reload the page
    if(directoryName == ""){
      UIkit.modal.alert("You must provide a directory name");
      return false;
    }
    axios.post('/directories/store', {
        name: directoryName
      })
      .then(function (response) {
        window.location.reload();
      })
      .catch(function (error) {
        console.error(error);
        rg4js('send', {
          error: error,
          customData: [error.response]
        });
      });

  }); 
}

/**
 * Delete an existing Directory
 */
function deleteDirectoryHandler(slug){

  UIkit.modal.confirm('Are you sure?').then(function() {

    axios.delete('/directories/destroy/'+slug)
      .then(function (response) {
        window.location.reload();
      })
      .catch(function (error) {
        console.error(error);
        rg4js('send', {
          error: error,
          customData: [error.response]
        });
      });

  });
}

function noGeolocationHandler(){
  $('.mp-requires-geo').addClass('uk-hidden');
}

function geoErrorHandler(error){
  console.log(error);
  $('.mp-requires-geo').addClass('uk-hidden');
  UIkit.notification({status: 'danger', message: '<span uk-icon=\'icon: warning\'></span> Something went wrong getting your location'});
}

function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}


// WEBPACK FOOTER //
// ./resources/assets/js/mp.js